

import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core'; 
import { faStar } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css']
})
export class CardComponent {
  @Input() cardTitle: string = '';
  @Input() cardImg: string = '';
  @Input() cardDescription: string = '';
  @Input() cardIcon: IconProp = faStar; //default value
  @Output() cardClicked: EventEmitter<void> = new EventEmitter<void>();

  onClick(): void {
    this.cardClicked.emit();
  }
}

